import { getPagePreviewSettingQuery, useQuery } from '@redlink/services';

const changeThemeColor = (color) => {
  var metaThemeColor = document.querySelector('meta[name=theme-color]');
  metaThemeColor.setAttribute('content', color);
};

export const usePageTheme = ({ pageName }) => {
  const { data = {} } = useQuery(getPagePreviewSettingQuery, {
    variables: { pageName },
    done: (data) => {
      const {
        PageSettingPreview: {
          theme: { palette: { background } = {} } = {},
        } = {},
      } = data;
      changeThemeColor(background);
    },
  });

  const {
    PageSettingPreview: {
      theme: {
        id: currentPreviewThemeId = '',
        palette: previewPalette = {},
      } = {},
    } = {},
  } = data;

  return {
    themeId: currentPreviewThemeId,
    palette: previewPalette,
  };
};
